import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import cloneDeep from "lodash-es/cloneDeep";
import cloneDeepWith from "lodash-es/cloneDeepWith";
import { finalize } from "rxjs";
import { SortDirection } from "@angular/material/sort";
import deepCastToInt from "src/app/_helpers/deepCastToInt";
import { LoadingTypeEnum } from "src/app/modules/shared/_enums/loading-type.enum";
import { BreadcrumbService } from "../../../../_services/breadcrumb.service";
import { ClientsService } from "../../../../_services/clients.service";
import {
  FundingRequestData,
  FundingRequestsService,
} from "../../../../_services/funding-requests.service";
import { ItemsListComponent } from "../../items-list/items-list.component";

@Component({
  selector: "app-client-funding-requests",
  templateUrl: "./client-funding-requests.component.html",
  styleUrls: ["./client-funding-requests.component.css"],
})
export class ClientFundingRequestsComponent
  extends ItemsListComponent
  implements OnInit
{
  items: FundingRequestData[] = [];
  clientId: number;
  active = "";
  direction: SortDirection = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fundingRequestsService: FundingRequestsService,
    private clientsService: ClientsService,
    private breadcrumbService: BreadcrumbService
  ) {
    super();
    this.clientId = Number(this.route.snapshot.parent.params.id);

    this.route.queryParams.subscribe((query) => {
      if (query && Object.keys(query).length > 0) {
        this.filters = cloneDeepWith(query, deepCastToInt);
      } else {
        this.clearFilters();
        this.filters = this.getParams(1);
      }

      if (this.filters["per_page"]) {
        this.perPage = this.filters["per_page"];
      }

      if (this.filters["order"]) {
        this.active = this.filters["order"];
        this.direction = this.filters["order_direction"];
      } else {
        this.active = "";
        this.direction = "";
      }

      this.getItems();
    });
  }

  ngOnInit() {
    this.clientsService.getClient(this.clientId).subscribe((data) => {
      this.breadcrumbService.changeBreadcrumbs(
        this.breadcrumbService.setForClient(data.result, "funding requests")
      );
    });
  }

  public getItems(page: number = 1): void {
    if (this.request_call) {
      this.request_call.unsubscribe();
    }

    this.isLoadingGeneral = true;
    const params = cloneDeep(this.filters);

    this.request_call = this.fundingRequestsService
      .getClientFundingRequests(this.clientId, params)
      .pipe(
        finalize(() => {
          this.isLoadingGeneral = false;
        })
      )
      .subscribe((data) => {
        this.processResponse(data);
      });
  }

  goToFundingRequest(fundingRequestId: number): void {
    this.router.navigate(
      [`/clients/${this.clientId}/funding-requests/${fundingRequestId}`],
      {
        queryParams: this.route.snapshot.queryParams,
      }
    );
  }

  navigateByUrl(page: number = 1): void {
    const params = this.getParams(page);

    this.router.navigate([`/clients/${this.clientId}/funding-requests`], {
      queryParams: params,
    });
  }

  protected getService() {
    return this.fundingRequestsService;
  }

  get LoadingType() {
    return LoadingTypeEnum;
  }
}
